export class MarketFinder {

    constructor ( target = '.js-market-finder', options = {} ) {
        this.target = target;

        this.options = {
            ...options
        }
    }

    init () {
        this.$container = document.querySelector( this.target );

        if(!this.$container ) {
            return;
        }

        this.$controls = this.$container.querySelectorAll('.js-market-finder__control');
        this.$images = this.$container.querySelectorAll('.js-market-finder__image');
        this.$copy = this.$container.querySelectorAll('.js-market-finder__copy');

        if(!(this.$controls && this.$images && this.$copy)) {
            return;
        }

        this.$controls.forEach( ( $control, index ) => {
            $control.addEventListener('click', () => {

                this.$controls.forEach( ( $item ) => {
                    $item.classList.remove('js-active');
                });

                this.$images.forEach( ( $image ) => {
                    $image.classList.remove('js-active');
                });

                this.$copy.forEach( ( $item ) => {
                    $item.classList.remove( 'js-active' );
                });

                $control.classList.add('js-active');
                this.$copy[index].classList.add('js-active');
                this.$images[index].classList.add('js-active');
            });
        } );

    }

}
